import {
  HoodDuctCoverHeight,
  HoodInsertChoice,
  HoodInsertModel,
  HoodModelNumber,
} from './Enums';

/**
 * @type {Object<HoodDuctCoverHeight, string>}
 */
export const ductCoverHeightLookup = {
  [HoodDuctCoverHeight.twoFifty]: '250mm (9 ⅞") [standard]',
  [HoodDuctCoverHeight.fiveHundred]: '500mm (19 ¹¹⁄₁₆") [custom]',
  [HoodDuctCoverHeight.sevenFifty]: '750mm (29 ½") [custom]',
  [HoodDuctCoverHeight.oneThousand]: '1,000mm (39 ⅜") [custom]',
};

/**
 * The width of each hood model in inches.
 * @type {Object<HoodModelNumber, string>}
 */
export const hoodWidthLookup = {
  [HoodModelNumber.LH900]: '35 7/16"',
  [HoodModelNumber.LH1100]: '43 5/16"',
  [HoodModelNumber.LH1200]: '47 1/4"',
  [HoodModelNumber.LH1300]: '51 3/16"',
  [HoodModelNumber.LH1600]: '63"',
  [HoodModelNumber.LH1700]: '66 15/16',
  [HoodModelNumber.LH2000]: '78 3/4"',
  [HoodModelNumber.LH2400]: '94 1/2"',
};

/**
 * Maps each hood insert model to its corresponding blower capacity (CFM).
 * @type {Object<HoodInsertModel, number>}
 */
export const insertBlowerCapacityLookup = {
  [HoodInsertModel.modernAire_PSL900]: 450,
  [HoodInsertModel.modernAire_PSL1100]: 600,
  [HoodInsertModel.modernAire_PSL1200]: 600,
  [HoodInsertModel.modernAire_PSL1300]: 600,
  [HoodInsertModel.modernAire_PSL1700]: 1200,
  [HoodInsertModel.modernAire_PSL2000]: 1500,
  [HoodInsertModel.modernAire_PSL2400]: 1800,
  [HoodInsertModel.ventAHood_BH228SLD]: 600,
  [HoodInsertModel.ventAHood_BH234SLD]: 600,
  [HoodInsertModel.ventAHood_BH240SLD]: 600,
  [HoodInsertModel.ventAHood_BH346SLD]: 900,
  [HoodInsertModel.ventAHood_M28SLD_single]: 625,
  [HoodInsertModel.ventAHood_M34SLD_single]: 625,
  [HoodInsertModel.ventAHood_M40SLD_single]: 625,
  [HoodInsertModel.ventAHood_M46SLD_single]: 625,
  [HoodInsertModel.ventAHood_M28SLD_dual]: 1015,
  [HoodInsertModel.ventAHood_M34SLD_dual]: 1015,
  [HoodInsertModel.ventAHood_M40SLD_dual]: 1015,
  [HoodInsertModel.ventAHood_M46SLD_dual]: 1015,
};

/**
 * The number of blower motors (for when we care).
 * @type {Object<HoodInsertModel, ?number>}
 */
export const insertBlowerMotors = {
  [HoodInsertModel.modernAire_PSL900]: null,
  [HoodInsertModel.modernAire_PSL1100]: null,
  [HoodInsertModel.modernAire_PSL1200]: null,
  [HoodInsertModel.modernAire_PSL1300]: null,
  [HoodInsertModel.modernAire_PSL1700]: null,
  [HoodInsertModel.modernAire_PSL2000]: null,
  [HoodInsertModel.modernAire_PSL2400]: null,
  [HoodInsertModel.ventAHood_BH228SLD]: null,
  [HoodInsertModel.ventAHood_BH234SLD]: null,
  [HoodInsertModel.ventAHood_BH240SLD]: null,
  [HoodInsertModel.ventAHood_BH346SLD]: null,
  [HoodInsertModel.ventAHood_M28SLD_single]: 1,
  [HoodInsertModel.ventAHood_M34SLD_single]: 1,
  [HoodInsertModel.ventAHood_M40SLD_single]: 1,
  [HoodInsertModel.ventAHood_M46SLD_single]: 1,
  [HoodInsertModel.ventAHood_M28SLD_dual]: 2,
  [HoodInsertModel.ventAHood_M34SLD_dual]: 2,
  [HoodInsertModel.ventAHood_M40SLD_dual]: 2,
  [HoodInsertModel.ventAHood_M46SLD_dual]: 2,
};

/**
 * Determine the hood insert manufacturer from the UI selection.
 * @type {Object<HoodInsertChoice, string>}
 */
export const insertManufacturerLookup = {
  [HoodInsertChoice.modernAire]: 'Modern-Aire Ventilation',
  [HoodInsertChoice.ventAHoodSingle]: 'Vent-A-Hood',
  [HoodInsertChoice.ventAHoodDual]: 'Vent-A-Hood',
  [HoodInsertChoice.ventAHoodMagicLung]: 'Vent-A-Hood',
};

/**
 * @type {Object<HoodInsertModel, string>}
 */
export const insertModelNumberLookup = {
  [HoodInsertModel.modernAire_PSL900]: 'PSL900',
  [HoodInsertModel.modernAire_PSL1100]: 'PSL1100',
  [HoodInsertModel.modernAire_PSL1200]: 'PSL1200',
  [HoodInsertModel.modernAire_PSL1300]: 'PSL1300',
  [HoodInsertModel.modernAire_PSL1700]: 'PSL1700',
  [HoodInsertModel.modernAire_PSL2000]: 'PSL2000',
  [HoodInsertModel.modernAire_PSL2400]: 'PSL2400',
  [HoodInsertModel.ventAHood_BH228SLD]: 'BH228SLD',
  [HoodInsertModel.ventAHood_BH234SLD]: 'BH234SLD',
  [HoodInsertModel.ventAHood_BH240SLD]: 'BH240SLD',
  [HoodInsertModel.ventAHood_BH346SLD]: 'BH346SLD',
  [HoodInsertModel.ventAHood_M28SLD_single]: 'M28SLD',
  [HoodInsertModel.ventAHood_M34SLD_single]: 'M34SLD',
  [HoodInsertModel.ventAHood_M40SLD_single]: 'M40SLD',
  [HoodInsertModel.ventAHood_M46SLD_single]: 'M46SLD',
  [HoodInsertModel.ventAHood_M28SLD_dual]: 'M28SLD',
  [HoodInsertModel.ventAHood_M34SLD_dual]: 'M34SLD',
  [HoodInsertModel.ventAHood_M40SLD_dual]: 'M40SLD',
  [HoodInsertModel.ventAHood_M46SLD_dual]: 'M46SLD',
};
